import React, { useState, useEffect } from 'react';
import CounsellorNavbar from '../CounsellorLayout/CounsellorNavbar';
import CounsellorSidebar from '../CounsellorLayout/CounsellorSidebar';
import CounsellorFooter from '../CounsellorLayout/CounsellorFooter';
import { Container, Card } from "react-bootstrap";
import { Calendar } from 'react-multi-date-picker';
import "react-multi-date-picker/styles/colors/teal.css"; // Optional: styling

const COUNSELOR_ID = 123;

const CounsellorSettings = () => {
  
  return (
    <>
      <CounsellorNavbar />

      <div className="d-flex">
        <CounsellorSidebar />
      
        <div style={{  paddingLeft: '30px', width: '100%', paddingBottom:'350px' }}>
        <br></br>
        <h2>Settings</h2>
        <br></br>
 

        </div>
        </div>
      <CounsellorFooter />
    </>
  );
};

export default CounsellorSettings;
